var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2442_3142)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.99989 9.41992C5.7849 9.41992 5.56987 9.33783 5.4059 9.17402L0.24617 4.01416C-0.0820565 3.68594 -0.0820565 3.15377 0.24617 2.82568C0.574263 2.49759 1.10632 2.49759 1.43457 2.82568L5.99989 7.39134L10.5654 2.826C10.8935 2.49791 11.4256 2.49791 11.7537 2.826C12.0821 3.15409 12.0821 3.6861 11.7537 4.01432L6.59404 9.17421C6.42999 9.33799 6.21495 9.41992 5.99989 9.41992Z",
    fill: "#04BA96"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2442_3142"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenChevron);
export default __webpack_public_path__ + "static/media/GreenChevron.7a8de19a9e1fb85d22bb318b53e52431.svg";
export { ForwardRef as ReactComponent };